import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { apiRequest } from "../services/allApi";
import { errorAlert, successAlert } from "../services/sweetAlert";

function Header() {
  const [isFixed, setIsFixed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const [siteData, setSiteData] = useState({});

  const SiteApi = async () => {
    try {
      const res = await apiRequest("site-settings");

      if (res?.success) {
        setSiteData(res.data);

        // ✅ FAVICON SET KARO
        const favicon = res?.data?.site_favicon;

        if (favicon) {
          let link = document.querySelector("link[rel*='icon']");

          if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.head.appendChild(link);
          }

          link.type = "image/png";
          link.href = favicon + "?v=" + new Date().getTime(); // cache fix
        }

        // ✅ TITLE bhi dynamic kar lo
        // if (res?.data?.site_name) {
        //   document.title = res.data.site_name;
        // }
      } else {
        errorAlert(res.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    SiteApi();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsFixed(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <header
        id="masthead"
        className={`site-header ${isFixed ? "fixed-header" : ""}`}
      >
        <div class="top-header bottom-header">
          <div class="container">
            <div class="top-header-inner">
              <div class="site-logo text-center">
                <h1 class="site-title">
                  <Link to="/" onClick={closeMobileMenu}>
                    {/* <img src={Logo} alt="Logo" /> */}
                    <img src={siteData?.site_footer_logo} alt="Logo" />
                  </Link>
                </h1>
              </div>

              {/* Mobile Toggle Button - Visible only at 991px and below */}
              <button
                className="mobile-toggle-btn d-lg-none"
                onClick={toggleMobileMenu}
                aria-label="Toggle mobile menu"
              >
                <span
                  className={`hamburger-line ${isMobileMenuOpen ? "open" : ""}`}
                ></span>
                <span
                  className={`hamburger-line ${isMobileMenuOpen ? "open" : ""}`}
                ></span>
                <span
                  className={`hamburger-line ${isMobileMenuOpen ? "open" : ""}`}
                ></span>
              </button>

              <div class="navigation-container d-none d-lg-block">
                <nav id="navigation" class="navigation">
                  <ul>
                    <li class="menu-active">
                      <Link to="/">Home</Link>
                    </li>

                    <li class="menu-item-has-children">
                      <Link to="/">Tours</Link>
                      <ul>
                        <li>
                          <Link to="/ladakh-bike-tour-packages">Bike Trip</Link>
                        </li>
                        <li>
                          <Link to="/ladakh-car-tour-packages"> Car Trip</Link>
                        </li>
                        {/* <li>
                          <Link to="/Trip">Rafting</Link>
                        </li> */}
                        <li>
                          <Link to="/premium-ladakh-tour-packages">
                            Premium Package
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <Link to="/rental"> Rental</Link>
                    </li>
                    <li>
                      <Link to="/gallary">Gallary</Link>
                    </li>
                    <li>
                      <Link to="/about-us">about us</Link>
                    </li>
                    <li>
                      <Link to="/contact-us">contact us</Link>
                    </li>
                  </ul>
                </nav>
              </div>

              <div class="header-btn d-none d-lg-block">
                <Link to="/contact-us" class="round-btn">
                  Book Now
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Menu Overlay */}
        <div
          className={`mobile-menu-overlay ${isMobileMenuOpen ? "active" : ""}`}
          onClick={closeMobileMenu}
        ></div>

        {/* Mobile Menu - Slides from left */}
        <div
          className={`mobile-menu-container d-lg-none ${isMobileMenuOpen ? "open" : ""}`}
        >
          <div className="mobile-menu-header">
            <h3>Menu</h3>
            <button className="mobile-close-btn" onClick={closeMobileMenu}>
              <i className="fas fa-times"></i>
            </button>
          </div>
          <nav className="mobile-navigation">
            <ul>
              <li>
                <Link to="/" onClick={closeMobileMenu}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about-us" onClick={closeMobileMenu}>
                  About Us
                </Link>
              </li>
              <li className="mobile-submenu">
                <span className="mobile-submenu-title">Tours</span>
                <ul>
                  <li>
                    <Link to="/Trip" onClick={closeMobileMenu}>
                      LEH LADAKH BIKE TOUR
                    </Link>
                  </li>
                  <li>
                    <Link to="/Trip" onClick={closeMobileMenu}>
                      Ladakh Car Trip
                    </Link>
                  </li>
                  <li>
                    <Link to="/Trip" onClick={closeMobileMenu}>
                      Rafting
                    </Link>
                  </li>
                  <li>
                    <Link to="/BikeRentel" onClick={closeMobileMenu}>
                      Bike Rental
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/gallary" onClick={closeMobileMenu}>
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/Faq" onClick={closeMobileMenu}>
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact-us" onClick={closeMobileMenu}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </nav>
          <div className="mobile-menu-footer">
            <Link
              to="/contact-us"
              className="round-btn"
              onClick={closeMobileMenu}
            >
              Book Now
            </Link>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
